import React, {
  createContext,
  useContext,
  useState,
  useRef,
  MutableRefObject,
  Dispatch,
} from "react";
import { ProductContext } from "./";
import { fabric } from "fabric";
import { BoxSize, ActiveObject } from "../../../Types";

interface CanvasProviderProps {
  children: JSX.Element;
}

interface CanvasContextTypes {
  originalCanvasSize: BoxSize | null;
  setOriginalCanvasSize: Dispatch<BoxSize | null>;
  scaledCanvasSize: BoxSize | null;
  setScaledCanvasSize: Dispatch<BoxSize | null>;
  canvasResizeCoef: number;
  setCanvasResizeCoef: Dispatch<number>;
  canvasRef: MutableRefObject<fabric.Canvas> | null;
  activeObject: ActiveObject | null;
  setActiveObject: Dispatch<ActiveObject | null>;
}

const CANVAS_CONTEXT_INITIAL_VALUES = {
  originalCanvasSize: null,
  setOriginalCanvasSize: (originalCanvasSize: BoxSize | null) => undefined,
  scaledCanvasSize: null,
  setScaledCanvasSize: (scaledCanvasSize: BoxSize | null) => undefined,
  canvasResizeCoef: 0,
  setCanvasResizeCoef: (canvasResizeCoef: number) => undefined,
  canvasRef: null,
  activeObject: null,
  setActiveObject: (object: fabric.Object) => undefined,
};

export const CanvasContext = createContext<CanvasContextTypes>({
  ...CANVAS_CONTEXT_INITIAL_VALUES,
});

function CanvasProvider({ children }: CanvasProviderProps) {
  // state
  const [originalCanvasSize, setOriginalCanvasSize] = useState<BoxSize | null>(
    null
  );
  const [scaledCanvasSize, setScaledCanvasSize] = useState<BoxSize | null>(
    null
  );
  const [canvasResizeCoef, setCanvasResizeCoef] = useState<number>(0);
  const [activeObject, setActiveObject] = useState<ActiveObject | null>(null);
  // ref
  const canvasRef = useRef<fabric.Canvas | null>(null);

  const providerValue = {
    canvasRef,
    originalCanvasSize,
    setOriginalCanvasSize,
    scaledCanvasSize,
    setScaledCanvasSize,
    canvasResizeCoef,
    setCanvasResizeCoef,
    activeObject,
    setActiveObject,
  };

  return (
    <CanvasContext.Provider value={providerValue}>
      {children}
    </CanvasContext.Provider>
  );
}

export default CanvasProvider;
